import jQuery from "jquery";
import { EventEmitter } from "events";
let $ = jQuery;
import {TweenMax} from "gsap/TweenMax";


export default class Auth extends EventEmitter {

    constructor() {
        super();

        this.ajax_url = (typeof cs_reg_vars !== "undefined") ? cs_reg_vars.cs_ajax_url : '';

        $(document).ready(()=>{

            this.$indicator = $('form .indicator');
            this.$loginFormMessage = $('#loginform .message');
            this.$registerFormMessage = $('#registerform .message');
            this.$resetFormMessage = $('#resetform .message');

            this.init();

            /**
             *
             * Automatically login in offline version, no credentials check
             *
             */
            if (location.protocol === 'file:')
                this._ui_login(true);
            else         // AutoLogin
                this.autologin();

        })




    }


    init() {
        this.$loginFormMessage.html('');
        this.$registerFormMessage.html('');
        this.$resetFormMessage.html('');

        this._initEvents();
        // Hide main UI ( TODO: to make this halfway secure, sync main script and do not load until this script is giving access )
    }


    /**
     * Autologin, DEPRECATED : PHP is taking care of this
     */
    autologin() {
        let self = this;
        this.$indicator.show();
        $.post(this.ajax_url, {action: 'autologin_user'}, function (response) {
            // If we have response
            if (response) {
                console.info('Attempting AUTOLOGIN : ')
                if (response === '1') {
                    // Logged in.
                    console.info('autologin succeeded.');
                    self._ui_login();
                }
                self.$indicator.hide();
            }
        });
    }


    _initEvents() {
        /**
         * Change UI to registration screen
         *
         */
        $('.show-registration').click( function(event) {
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            // Assume user has xxx password ( see below ) // Note: new since v 2 -- password not required
            $('#registerform #haspassword').val(1);
            //
            $('body').addClass('show-registration').removeClass('show-reset');
        });

        /**
         * Change UI to login screen
         *
         */
        $('.show-login').click( function(event) {
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            $('body').removeClass('show-registration').removeClass('show-reset');
        });

        /**
         * Password reset action : DEPRECATED
         *
         */
        $('.reset-password').click( function(event) {
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            $('body').addClass('show-reset').removeClass('show-registration');
        });

        /**
         * Login action
         *
         */
        $('#login').click( (event)=> {
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            this.$indicator.show();
            var reg_nonce = $('#new_user_nonce').val();
            var reg_pass  = $('#login-password').val();
            var reg_mail  = $('#login-email').val();
            var data = {
                action: 'login_user',
                nonce: reg_nonce,
                pass: reg_pass,
                mail: reg_mail
            }

            // ------------



            // Do AJAX request
            $.post( this.ajax_url, data, (response)=> {

                // If we have response
                if( response ) {
                    this.$indicator.hide();

                    var response = parseInt(response);
                    // console.log(response === 1, response === 2)

                    if (response == '1') {
                        // Standard login
                        this._ui_login();

                    } else if (response == '2') {
                        // Right password, but not registered yet
                        $('body').addClass('show-registration').removeClass('show-reset');
                        $('#registerform #email').val($('#loginform #login-email').val());
                        $('#registerform #haspassword').val(1);
                        $('#register-note').show();

                    } else {
                        $('#loginform .message').html('Sorry, this Email is unknown. Please register with a valid email.')
                    }
                }
            });


        });


        /**
         * Registration action
         *
         *
         */
        $('#register').click( (event)=> {

            let self = this;

            /**
             * Prevent default action, so when user clicks button he doesn't navigate away from page
             *
             */
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            // Show 'Please wait' loader to user, so she/he knows something is going on
            $('.indicator').show();

            // If for some reason result field is visible hide it
            $('.message').hide();

            // Collect data from inputs
            var reg_nonce = $('#new_user_nonce').val();
            var reg_user  = $('#companyname').val();
            var reg_pass  = $('#pass').val();
            var reg_mail  = $('#email').val();
            var reg_name  = $('#name').val();
            var reg_phone = $('#phone').val();
            var reg_haspw = 1;// $('#haspassword').val();

            //// 2. Send to CMS


            // Data to send
            let data = {
                action: 'register_user',
                nonce: reg_nonce,
                companyname: reg_user,
                pass: reg_pass,
                email: reg_mail,
                name: reg_name,
                phone: reg_phone,
                haspassword: reg_haspw
            };

            // Do AJAX request
            $.post( this.ajax_url, data, function(response) {

                // If we have response
                if( response ) {

                    // Hide 'Please wait' indicator
                    $('.indicator').hide();

                    $('#registerform .message').show();
                    if( response === '1' ) {
                        // If user is created
                        this.$registerFormMessage.html('Thank you for requesting access. We will be in touch soon.');
                        $('#registerform .formfields').hide();
                    }
                    else if( response === '2' ) {
                        self._ui_login();
                    }
                    else if( response === '-1' ) {
                        // No proper credentials
                        $('#registerform .message').html('Please fill in the field correctly.');
                    } else {
                        $('#registerform .message').html('This user already exists. Please request a new password or reset it here.');
                    }
                }
            });

        });


        /**
         * Reset password action : DEPRECATED
         *
         *
         */
        $('#resetpass').click( (event)=> {

            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            // Show 'Please wait' loader to user, so she/he knows something is going on
            $('.indicator').show();

            // If for some reason result field is visible hide it
            $('.message').hide();

            // Collect data from inputs
            var reg_nonce = $('#new_user_nonce').val();
            var reg_mail  = $('#reset-email').val();



            // Data to send
            data = {
                action: 'cs_resetpass',
                nonce: reg_nonce,
                mail: reg_mail
            };

            // Do AJAX request
            $.post( this.ajax_url, data, function(response) {

                // If we have response
                if( response ) {

                    // Hide 'Please wait' indicator
                    $('.indicator').hide();
                    // Check response
                    if( parseInt(response) == 1 ) {
                        // If user is created
                        $('#resetform .message').html('Thank you for requesting access. We will be in touch soon.');
                        $('#resetform .message').show();
                    } else {
                        $('#resetform .message').html('This user does not exist. Please register.');
                        $('#resetform .message').show();
                    }
                }
            });

        });

    }



    /**
     * This works only in conjunction with EXTERNAL TweenMax // GSAP
     * There is NO error checking for it!
     * @private
     */
    _ui_login(fast) {
        let speed = (fast) ? 0.1 : 1;
        TweenMax.to('#login-wrapper', speed, {alpha:0, "display":"none", onComplete:function () {
            $('#login-wrapper').remove();
        }});


        //Emit AUTH event
        this.emit('auth.success');

    }


}
